import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Tips = () => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 612 612" style={{fill: 'currentColor'}}>
      <path d="M306.001,23.596c-118.01,0-214.019,96.011-214.019,214.023c0,83.39,47.946,155.785,117.712,191.09v127.48
				c0,30.775,25.038,55.811,55.811,55.811h80.992c30.773,0,55.811-25.038,55.811-55.811V428.708
				c69.766-35.303,117.715-107.699,117.715-191.088C520.023,119.607,424.011,23.596,306.001,23.596z M322.646,414.572
				c-5.483,0.511-11.034,0.786-16.646,0.786c-5.616,0-11.167-0.275-16.65-0.786c1.24-24.823,0.638-72.259-16.962-113.969h67.222
				C322.011,342.314,321.409,389.751,322.646,414.572z M366.028,519.152H245.974v-76.096c19.053,5.577,39.194,8.582,60.027,8.582
				s40.974-3.004,60.027-8.582V519.152z M366.028,556.188c0,10.771-8.76,19.531-19.531,19.531h-80.992
				c-10.771,0-19.531-8.762-19.531-19.531v-0.756h120.054V556.188z M358.717,407.377c-0.842-27.958,1.487-79.666,26.262-114.374
				c3.947-5.53,4.473-12.802,1.363-18.843c-3.109-6.041-9.336-9.836-16.129-9.836H241.787c-6.793,0-13.017,3.797-16.126,9.836
				c-3.113,6.041-2.583,13.313,1.364,18.843c24.775,34.711,27.101,86.424,26.259,114.374
				c-72.347-22.513-125.022-90.1-125.022-169.759c0-98.007,79.731-177.743,177.739-177.743s177.742,79.736,177.742,177.743
				C483.743,317.278,431.064,384.865,358.717,407.377z"/>
			<path d="M71.591,78.157c3.543,3.542,8.184,5.314,12.825,5.314c4.644,0,9.285-1.772,12.828-5.315
				c7.084-7.084,7.084-18.569,0-25.653L50.053,5.314c-7.085-7.085-18.571-7.085-25.655,0c-7.082,7.085-7.082,18.569,0,25.653
				L71.591,78.157z"/>
			<path d="M527.584,83.47c4.644,0,9.286-1.772,12.828-5.314l47.187-47.188c7.087-7.085,7.087-18.569,0-25.655
				s-18.571-7.084-25.655,0l-47.187,47.188c-7.087,7.085-7.087,18.571,0,25.655C518.301,81.698,522.942,83.47,527.584,83.47z"/>
			<path d="M540.412,397.078c-7.084-7.085-18.568-7.087-25.654-0.002c-7.087,7.085-7.087,18.569,0,25.653l47.187,47.191
				c3.543,3.543,8.184,5.314,12.828,5.314c4.641,0,9.283-1.772,12.825-5.314c7.087-7.082,7.087-18.569,0-25.653L540.412,397.078z"/>
			<path d="M71.591,397.076l-47.193,47.191c-7.082,7.084-7.082,18.569,0,25.655c3.543,3.542,8.184,5.314,12.828,5.314
				c4.641,0,9.286-1.77,12.825-5.314l47.193-47.191c7.084-7.085,7.084-18.569,0-25.655
				C90.162,389.991,78.675,389.991,71.591,397.076z"/>
    </SvgIcon>
  );
}

export default Tips;
